<template>
  <div class="losscustomerManage">
    <PageNav :slider="slider" :openMenu="openMenu">
      <el-main>
        <div id="page-losscustomerManage">
          <div class="head-tab--nav">
            <div class="head-nav h-3">
              <!-- <span>招生CRM</span>
              <span>></span>-->
              <span class="c-normal">{{ $t("Losscustomermanage.as") }}</span>
              <div class="pull-right">
                <el-button type="primary" @click="daochu">
                  {{ $t("Common.btn_export") }}
                </el-button>
              </div>
            </div>
          </div>
          <div class="losscustomerManage-container">
            <div
              class="content"
              :class="{ 'content-special': postbe_crmlevel == '1' }"
            >
              <div
                v-if="postbe_crmlevel == '1'"
                class="content-nav--head text-1 Tab-nav-head"
              >
                <div class="c-n--head_lf">
                  <ul class="filter-condition">
                    <li
                      v-for="(item, index) in filtersOption"
                      :key="index"
                      :class="{ 'link-active': index == current }"
                      @click="addClass(index)"
                    >
                      {{ item }}
                    </li>
                  </ul>
                </div>
                <div class="c-n--head_rt"></div>
              </div>
              <div class="content-nav--head text-1">
                <!-- <div class="c-n--head_lf">
                  <span class="mr10">无意向客户管理</span>
                </div>-->
                <div class="c-n--head_lf">
                  <template v-if="!buttonHide">
                    <div class="flex-al mr10">
                      <span class="mr10 fs14 color-666">
                        {{ $t("Losscustomermanage.ba") }}:</span
                      >
                      <div class="time-box">
                        <el-date-picker
                          v-model="selectForm.rangeTime"
                          type="daterange"
                          style="width: 260px"
                          :range-separator="$t('Common.to')"
                          value-format="yyyy-MM-dd"
                          :start-placeholder="$t('Common.startTime')"
                          :end-placeholder="$t('Common.endTime')"
                          @change="handleSelect()"
                        ></el-date-picker>
                      </div>
                    </div>
                    <div class="flex-al mr10">
                      <span class="mr10 fs14 color-666">
                        {{ $t("Losscustomermanage.bb") }}:
                      </span>
                      <div class="rate-box flex-al">
                        <el-rate
                          v-model="selectForm.client_intention_maxlevel"
                          @change="handleSelectLevel()"
                          class="client-level-rate level-rate-fliter"
                          :icon-classes="[
                            'crm-likes',
                            'crm-likes',
                            'crm-likes',
                          ]"
                          void-icon-class="crm-like"
                          :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
                        ></el-rate>
                      </div>
                    </div>
                    <div class="flex-al mr10">
                      <el-select
                        filterable
                        clearable
                        v-model="selectForm.source"
                        style="width: 180px"
                        :placeholder="$t('Losscustomermanage.ac')"
                        @change="handleSelect()"
                      >
                        <el-option
                          v-for="item in SchoolsourceOption"
                          :key="item.frommedia_id"
                          :label="item.frommedia_name"
                          :value="item.frommedia_name"
                        ></el-option>
                      </el-select>
                    </div>
                    <div class="flex-al mr10">
                      <el-select
                        filterable
                        v-model="selectForm.ishaveaudition"
                        style="width: 180px"
                        clearable
                        :placeholder="$t('Losscustomermanage.bc')"
                        @change="handleSelect()"
                      >
                        <el-option label="是" value="1"></el-option>
                        <el-option label="否" value="0"></el-option>
                      </el-select>
                    </div>
                    <el-input
                      style="width: 200px"
                      clearable
                      :placeholder="$t('Losscustomermanage.bd')"
                      class="input-cont"
                      @change="handleSelectKeyword()"
                      v-model="selectForm.keyword"
                    ></el-input>
                    <el-button
                      type="primary"
                      class="btn-inquire"
                      @click="handleSelectKeyword()"
                    >
                      {{ $t("Losscustomermanage.ae") }}
                    </el-button>
                  </template>
                  <el-button
                    plain
                    v-if="buttonHide && postbe_crmlevel == '1'"
                    @click="changeLossClientData()"
                    >{{ $t("Losscustomermanage.af") }}</el-button
                  >
                  <el-button
                    plain
                    v-if="buttonHide && postbe_crmlevel == '1'"
                    @click="changeLossIntentionData()"
                    >{{ $t("Losscustomermanage.at") }}</el-button
                  >
                  <el-button
                    plain
                    v-if="buttonHide && postbe_crmlevel == '1'"
                    @click="visible = true"
                    >{{ $t("Losscustomermanage.be") }}</el-button
                  >
                  <el-button
                    plain
                    v-if="buttonHide && postbe_crmlevel == '1' && current != 0"
                    @click="changeSchoolVisible = true"
                  >
                    {{ $t("Losscustomermanage.bf") }}
                  </el-button>
                </div>
              </div>

              <TableList
                :list="tableData"
                :options="optionscaozuo"
                :columns="columns"
                :operates="operates"
                @handleSelectionChange="handleSelectionChange"
                @handleColumnChange="handleColumnChange"
                :issetting="true"
                :tableOperate="tableOperate"
                @toggleEditableColumn="toggleEditableColumn"
              ></TableList>

              <el-pagination
                style="margin-top: 35px"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="dataNumber"
              ></el-pagination>
            </div>
          </div>
        </div>
      </el-main>
    </PageNav>
    <!-- 侧边栏查看-->
    <SliderBox
      :showSliderBox="showSliderBoxSee"
      @hideSliderBox="hideSliderSeeBox"
      :sliderWidth="sliderWidth"
    >
      <userSeeing
        :showUserSliderBox="showSliderBoxSee"
        :createJG="createJG"
        :customerId="customerId"
        :ClassMessage="ClassMessage"
        :seeSliderTitle="seeSliderTitle"
        :isTrack="isTrack"
        :isRoot="isRoot"
        :isshowfirst="true"
        :isForm="true"
        :isHome="true"
        :isnotBiding="true"
        @hideUserSliderBox="hideSliderSeeBox"
        @studentBinding="studentBinding"
        @handleSliderClick="handleSliderClick"
        @Clickedit="Clickedit"
        @leaning="leaning"
        @onFllowSubmit="onFllowSubmit"
        @ClickFloow="ClickFloow"
        @updateList="updateList"
      ></userSeeing>
    </SliderBox>
    <!-- 审核 -->
    <el-dialog
      :title="$t('Losscustomermanage.au')"
      :visible.sync="ReviewVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="del-box">
        <div class="delTips tc">{{ $t("Losscustomermanage.ag") }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ReviewVisible = false">{{
          $t("Losscustomermanage.ah")
        }}</el-button>
        <el-button type="primary" @click="handleReviewkConfim()">{{
          $t("Losscustomermanage.ai")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 编辑列 -->
    <el-dialog
      :title="$t('Admissioncue.dy')"
      class="setting-column"
      :visible.sync="settingVisible"
      width="450px"
      :before-close="handleClose"
    >
      <el-transfer
        :titles="[$t('Admissioncue.bo'), $t('Admissioncue.bp')]"
        v-model="oprateColumn"
        @change="Changeoprate()"
        :data="data"
      ></el-transfer>
      <div class="oprate">
        <el-button type="primary" size="small" @click="handClickOprate()">{{
          $t("Admissioncue.ax")
        }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="$t('Losscustomermanage.ca')"
      :visible.sync="visible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="del-box">
        <div class="delTips tc">{{ $t("Losscustomermanage.cb") }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{
          $t("Crmactivemanage.bb")
        }}</el-button>
        <el-button type="primary" @click="changeLossClientTmkApi">{{
          $t("Crmactivemanage.bc")
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('Losscustomermanage.bf')"
      :visible.sync="changeSchoolVisible"
      width="550px"
      :before-close="handleClose"
      v-if="changeSchoolVisible"
    >
      <el-form
        label-width="110px"
        :model="changeSchoolFormData"
        ref="changeSchoolForm"
      >
        <p style="padding: 0 0 20px 50px">
          {{ $t("Losscustomermanage.bg") }}:
          <span style="color: #20a8d8">{{ MultipleClues.length }}</span>
        </p>
        <el-form-item
          :label="$t('Losscustomermanage.bh')"
          prop="school_id"
          :rules="[{ required: true, message: $t('Losscustomermanage.bj') }]"
        >
          <el-select
            v-model="changeSchoolFormData.school_id"
            style="width: 320px"
            :placeholder="$t('Losscustomermanage.bj')"
            clearable
            filterable
          >
            <el-option
              v-for="item in changeSchoolFormData.schoolList"
              :key="item.school_id"
              :label="item.school_cnname"
              :value="item.school_id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('Losscustomermanage.bk')" prop="reason">
          <el-input
            v-model="changeSchoolFormData.reason"
            style="width: 320px"
            :placeholder="$t('Losscustomermanage.bl')"
            type="textarea"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changeSchoolVisible = false">{{
          $t("Crmactivemanage.bb")
        }}</el-button>
        <el-button type="primary" @click="handleChangeSchool">{{
          $t("Crmactivemanage.bc")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import PageNav from "@/components/Nav/nav.vue";
// import echarts from "echarts";
import SliderBox from "@/components/SliderBox";
import TableList from "@/components/Table/table.vue";
import userSeeing from "@/components/User/seeing.vue";
import storeLosscustomerManage from "./losscustomerManage.js";
import storeInvitationauditionmanage from "../Invitationauditionmanage/Invitationauditionmanage.js";
import storeAdmissionCue from "@/views/Admissioncue/admissionCue.js";

export default {
  name: "losscustomerManage-losscustomerManage",
  data() {
    return {
      changeSchoolVisible: false,
      changeSchoolFormData: {
        schoolList: [],
        school_id: "",
        reason: "",
      },
      visible: false,
      openMenu: ["6"],
      settingVisible: false,
      data: [],
      oprateColumn: [1, 4], //编辑列

      showSliderBox: false,
      showSliderBoxSee: false,
      leaningVisible: false,
      createJG: false,
      ReviewVisible: false, //是否审核
      seeSliderTitle: this.$t("Losscustomermanage.av"),
      clientLevelNum: "", //存储意向星级数目
      ClassMessage: {}, //选择的试听班级
      inviteInfor: [],
      customerId: "", // 客户id
      isTrack: false, //是否点击跟进
      isRoot: false,
      current: 0,
      filtersOption: [
        this.$t("Losscustomermanage.ak"),
        this.$t("Losscustomermanage.al"),
      ],
      //绑定学员
      BindstudentFrom: {
        name: "",
        relation: "",
      },
      chiefPerson: [], //主负责人
      fu_chiefPerson: [], //副负责人
      FriendName: [], //用户绑定人员名称
      FriendRelation: [], //用户绑定关系
      followFormid: "",
      layoutVisible: false, //分配

      fullscreenLoading: true, //全屏loading
      currentPage: 1,
      // 分页的数据
      dataNumber: 0, //数据总数
      pagenum: "1",
      pagesize: 10,
      basicinformation: [],
      dialogVisible: false,
      //筛选条件
      selectForm: {
        rangeTime: "",
        level: null,
        source: "",
        keyword: "",
      },
      // 招生渠道类型
      SchoolsourceOption: [],
      visitedJG: false,
      visitingJG: false,
      levelNum: 5, //侧边栏个数
      sliderWidth: "700px", //侧边栏宽度
      activeName: "first",
      buttonHide: false,
      // 侧边栏 资料建档

      // 表格数据
      columnWidth: ["200", "200", "150", "150", "250", "250", "250", "250"], //表格宽度
      tableData: [],
      optionscaozuo: {
        mutiSelect: true, // 是否支持列表项选中功能
        loading: true, //数据loading
        highlightCurrentRow: true, // 是否支持当前行高亮显示
        tableHeight: Number, //表格高度
        errortip: "",
        // specialColumns:true//特殊列
      },
      tableOperate: {
        label: "11",
        operate: true,
        align: "center",
        fixed: "right",
      },
      columns: [],
      operates: {
        width: 150,
        label: this.$t("Losscustomermanage.am"),
        align: "center",
        fixed: "right",
        list: [
          {
            id: "1",
            label: this.$t("Losscustomermanage.au"),
            type: "text",
            show: true,
            plain: true,
            ischaserlapsed: true,
            disabled: false,
            method: (index, row) => {
              this.ReviewVisible = true;
              this.customerId = row.client_id; //存储客户ID
            },
          },
        ],
      }, // 列操作按钮
      defaultProps: {
        children: "children",
        label: "label",
      },
    };
  },
  components: {
    PageNav,
    SliderBox,
    userSeeing,
    TableList,
  },
  updated() {
    this.fullscreenLoading = false;
  },
  created() {
    
    this.slider = this.$store.state.Slider;
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;
    this.postbe_crmuserlevel = this.$Tool.getStorage("PostbeCrmlevel")
      ? this.$Tool.getStorage("PostbeCrmlevel")
      : "";
    this.re_postbe_id = this.$Tool.getStorage("re_postbe_id")
      ? this.$Tool.getStorage("re_postbe_id")
      : "";
    this.language_type = this.$Tool.getStorage("language")
      ? this.$Tool.getStorage("language")
      : "";
    // 权限判断
    this.postbe_crmlevel = this.$store.state.POSTBE_CRMLEVEL;
    if (this.postbe_crmlevel == "1") {
      this.getLossclientData("0");
      this.optionscaozuo.tableHeight = this.$Common.getTableHeight(340); //设置表格高度
    } else {
      this.current = 1;
      this.operates.list = [];
      this.getLossclientData("1");
      this.optionscaozuo.tableHeight = this.$Common.getTableHeight(340); //设置表格高度
    }

    this.getSource();
  },
  mounted() {
    this.getAllSchoolApi();
  },
  methods: {
    handleChangeSchool() {
      this.$refs["changeSchoolForm"].validate((v) => {
        if (v) {
          this.MultipleClues.forEach((v) => {
            this.transferSchoolAction(
              v.client_id,
              this.changeSchoolFormData.school_id,
              this.changeSchoolFormData.reason
            );
          });
        } else {
          return;
        }
      });
    },
    transferSchoolAction(client_id, re_school_id, note) {
      storeAdmissionCue
        .transferSchoolAction({
          client_id,
          re_school_id,
          note,
          school_id: this.$store.state.SCHOOL_ID,
        })
        .then((res) => {
          const { code, msg } = res.data;
          this.$message({
            message: msg,
            type: code === 200 ? "success" : "error",
          });
          if (res.data.code === 200) {
            this.updateList();
            this.changeSchoolVisible = false;
          }
        });
    },
    // 获取转校学校列表
    getAllSchoolApi() {
      storeAdmissionCue.getAllSchoolApi({}).then((res) => {
        this.changeSchoolFormData.schoolList = res.data.data.list;
      });
    },
    updateList() {
      this.getLossclientData(this.current);
    },
    // 显示 列切换
    toggleEditableColumn() {
      (() => {})("显示 列切换");
      this.settingVisible = !this.settingVisible;
    },
    // 自定义编辑列
    handClickOprate() {
      let allnum = JSON.parse(
        localStorage.getItem(`getLossclientColumns${this.current}`)
      );
      allnum.forEach((item, index) => {
        allnum[parseInt(index)].show = "1";
      });
      this.oprateColumn.forEach((item) => {
        allnum[parseInt(item)].show = "0";
      });
      this.showColumns = allnum;
      this.$Tool.setStorage(
        `showGetLossclientColumns${this.current}`,
        this.showColumns
      );
      this.settingVisible = false;
      this.getLossclientData(this.current);
      (() => {})(allnum);
    },
    // 编辑列
    Changeoprate() {
      (() => {})("列变化");
    },
    // 无意向客户管理表格数据
    getLossclientData(type) {
      var $source = this.selectForm.source;
      if ($source == this.$t("Losscustomermanage.an")) {
        $source = "";
      }
      storeLosscustomerManage
        .getLossclient({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id,
          is_count: "1", //是否需要总数，可以不传
          p: this.currentPage,
          num: this.pagesize,
          // 非必须传
          client_source: $source,
          create_starttime: this.selectForm.rangeTime
            ? this.selectForm.rangeTime[0]
            : "",
          create_endtime: this.selectForm.rangeTime
            ? this.selectForm.rangeTime[1]
            : "",
          client_intention_maxlevel:
            this.selectForm.client_intention_maxlevel || "",
          ishaveaudition: this.selectForm.ishaveaudition,
          keyword: this.selectForm.keyword,
          client_ischaserlapsed: type, //必传 待审核的客户列表传0 已确认无意向审核列表传1
        })
        .then((res) => {
          // 
          const { code, msg, data: body } = res.data;
          const allnum = body.allnum;
          const data = body;
          this.tableData = data.list;
          this.dataNumber = parseInt(allnum);

          var Columns = data.field;
          this.$Tool.setStorage(`getLossclientColumns${this.current}`, Columns);
          if (
            JSON.parse(
              localStorage.getItem(`showGetLossclientColumns${this.current}`)
            )
          ) {
            Columns = JSON.parse(
              localStorage.getItem(`showGetLossclientColumns${this.current}`)
            );
          }

          this.columns = this.$Common.handleTable(
            Columns,
            this.columnWidth,
            true,
            0
          );
          this.columns.forEach((v) => {
            if (v.prop == "client_tag") {
              this.$set(v, "istag", true);
              this.$set(v, "width", "220px");
            }
          });
          this.optionscaozuo.loading = false;
          if (code !== 200) {
            this.optionscaozuo.errortip = msg;
          }

          var arr = [];
          var arr2 = [];
          Columns.forEach((item, index) => {
            arr.push({
              key: index,
              label: item.fieldstring,
              disabled: item.custom === "0",
            });
            if (item.show == "0") {
              arr2.push(index);
            }
          });
          this.data = arr;
          this.oprateColumn = arr2;
        });
    },
    // 获取招生渠道类型
    getSource() {
      storeLosscustomerManage
        .getSource({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          (() => {})(res.data.data.list);
          this.SchoolsourceOption = res.data.data.list;
        });
    },
    // 主管审核
    lossExamine() {
      storeLosscustomerManage
        .lossExamine({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          client_id: this.customerId,
        })
        .then((res) => {
          (() => {})(res.data);
          if (res.data.code === 200) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            if (this.postbe_crmlevel == "1") {
              if (this.current == 0) {
                this.getLossclientData("0");
              } else {
                this.getLossclientData("1");
              }
            } else {
              this.getLossclientData("1");
            }
            this.ReviewVisible = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    handleSelectLevel() {
      if (this.clientLevelNum == this.selectForm.client_intention_maxlevel) {
        this.selectForm.client_intention_maxlevel = null;
        this.clientLevelNum = "";
      } else {
        this.clientLevelNum = this.selectForm.client_intention_maxlevel;
      }
      this.handleSelect();
    },
    // 选择查询
    handleSelect() {
      this.currentPage = 1;
      if (this.postbe_crmlevel == "1") {
        if (this.current == 0) {
          this.getLossclientData("0");
        } else {
          this.getLossclientData("1");
        }
      } else {
        this.getLossclientData("1");
      }
    },
    // 输入关键词查询
    handleSelectKeyword() {
      this.currentPage = 1;
      if (this.postbe_crmlevel == "1") {
        if (this.current == 0) {
          this.getLossclientData("0");
        } else {
          this.getLossclientData("1");
        }
      } else {
        this.getLossclientData("1");
      }
    },
    // 无意向客户管理->转为招生有效名单或无意向
    changeLossClientData() {
      (() => {})(this.MultipleClues);
      var arrMultiple = [];
      this.MultipleClues.forEach((item) => {
        arrMultiple.push(item.client_id);
      });
      storeLosscustomerManage
        .changeLossClient({
          marketer_id: this.marketer_id,
          token: this.token,
          client_id: arrMultiple,
        })
        .then((res) => {
          (() => {})(res.data);
          if (res.data.code === 200) {
            // this.$Tool.successTip(res.data.msg);
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            if (this.postbe_crmlevel == "1") {
              if (this.current == 0) {
                this.getLossclientData("0");
              } else {
                this.getLossclientData("1");
              }
            } else {
              this.getLossclientData("1");
            }
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    changeLossClientTmkApi() {
      var arrMultiple = [];
      this.MultipleClues.forEach((item) => {
        arrMultiple.push({ client_id: item.client_id });
      });
      storeLosscustomerManage
        .changeLossClientTmkApi({
          moduletype: -1,
          clients_json: JSON.stringify(arrMultiple),
        })
        .then((res) => {
          const { code, msg } = res.data;
          if (code === 200) {
            this.$message.success(msg);
            if (this.postbe_crmlevel == "1") {
              if (this.current == 0) {
                this.getLossclientData("0");
              } else {
                this.getLossclientData("1");
              }
            } else {
              this.getLossclientData("1");
            }
            this.visible = false;
          } else {
            this.$message.error(msg);
          }
        });
    },
    // 无意向客户管理->转为意向客户
    changeLossIntentionData() {
      var arrMultiple = [];
      this.MultipleClues.forEach((item) => {
        arrMultiple.push(item.client_id);
      });
      storeLosscustomerManage
        .changeLossIntention({
          marketer_id: this.marketer_id,
          token: this.token,
          client_id: arrMultiple,
        })
        .then((res) => {
          (() => {})(res.data);
          if (res.data.code === 200) {
            // this.$Tool.successTip(res.data.msg);
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            if (this.postbe_crmlevel == "1") {
              if (this.current == 0) {
                this.getLossclientData("0");
              } else {
                this.getLossclientData("1");
              }
            } else {
              this.getLossclientData("1");
            }
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    hideSliderSeeBox() {
      this.showSliderBoxSee = false;
    },
    //跟班试听
    leaning() {
      this.leaningVisible = true;
    },
    // 获取单个客户的绑定关系
    getFriendRelationData(id) {
      storeInvitationauditionmanage
        .getFriendRelation({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          client_id: id,
        })
        .then((res) => {
          (() => {})(res.data.data.list);
          this.FriendRelation = res.data.data.list;
        });
    },
    // 绑定学员->获取人员名称
    getClientNameData(keyword) {
      storeInvitationauditionmanage
        .getClientName({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          client_cnname: keyword,
        })
        .then((res) => {
          // (() => {})(res.data.data.list);
          this.FriendName = res.data.data.list;
          this.loading = false;
        });
    },
    // 远程搜索绑定学员的名称
    remoteMethod(query) {
      (() => {})(query);
      if (query !== "") {
        this.loading = true;
        this.getClientNameData(query);
      } else {
        this.FriendName = [];
      }
    },
    //绑定学员提交
    onBindSubmit() {
      // (() => {})(this.BindstudentFrom);
      storeInvitationauditionmanage
        .bindingClient({
          token: this.token,
          marketer_id: this.marketer_id,
          from_client_id: this.from_client_id,
          to_client_id: this.BindstudentFrom.name,
          binding_friend_relation: this.BindstudentFrom.relation,
        })
        .then((res) => {
          // (() => {})(res.data);
          if (res.data.code === 200) {
            // this.$Tool.successTip(res.data.msg);
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getAuditionData(this.pagenum, "");
            this.createJG = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    // 绑定学员显示
    studentBinding() {
      this.BindstudentFrom = {
        name: "",
        relation: "",
      }; //数据初始化
      this.getFriendRelationData();
      this.createJG = true;
    },
    //查看点击编辑
    Clickedit() {
      this.showSliderBoxSee = false;
      this.showSliderBox = true;
    },
    //点击查看
    handleColumnChange(k, v) {
      this.isRoot = false;
      this.activeName = "first";
      this.iscanEdit = true;
      this.from_client_id = v.client_id;
      this.customerId = v.client_id; //存储客户ID
      // this.getclientOneData(v.client_id);
      // this.getclientOneTrackData(v.client_id);
      // this.getFriendRelationData(v.client_id);
      // this.getclientOneInviteData(v.client_id); //柜询记录
      // this.getclientOneAuditionData(v.client_id); //试听记录
      // this.getBindingClientData(v.client_id);//绑定学员信息
      this.showSliderBoxSee = true;
    },
    //跟进提交
    onFllowSubmit(v) {
      // v.track_intention_level = this.clientLevelNum.length;
      v.token = this.token;
      v.marketer_id = this.marketer_id;
      v.school_id = this.school_id;
      v.company_id = this.company_id;
      if (this.followFormid != "") {
        v.client_id = this.followFormid;
      }
      // v.client_id=this.followFormid;
      (() => {})(v);
      storeInvitationauditionmanage.settingtrackClient(v).then((res) => {
        (() => {})(res.data);
        if (res.data.code === 200) {
          // this.$Tool.successTip(res.data.msg);
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.getAuditionData(this.pagenum, "");
          this.showSliderBoxSee = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    // 绑定学员点击跟进
    ClickFloow(v) {
      this.customerId = v.client_id;
    },
    hideSliderSeeBox() {
      this.showSliderBoxSee = false;
    },
    handleSliderClick(v) {
      (() => {})(v), 11111111;
      if (v == "first") {
        this.iscanEdit = true;
        //  this.getclientOneData(this.customerId);
      } else {
        if (v == "fourth") {
          this.isRoot = true;
        } else {
          this.iscanEdit = false;
          // this.isRoot=false;
        }
      }
    },
    //跟班试听
    leaning() {
      this.leaningVisible = true;
    },
    // 审核确定
    handleReviewkConfim() {
      this.lossExamine(); // 主管审核
    },
    handleClose(done) {
      this.$confirm(this.$t("Losscustomermanage.ao"))
        .then((_) => {
          (() => {})(_);
          done();
        })
        .catch((_) => {
          (() => {})(_);
        });
    },
    handleSizeChange(val) {
      (() => {})(`每页 ${val} 条`);
      this.pagesize = val;
      if (this.postbe_crmlevel == "1") {
        if (this.current == 0) {
          this.getLossclientData("0");
        } else {
          this.getLossclientData("1");
        }
      } else {
        this.getLossclientData("1");
      }
    },
    handleCurrentChange(val) {
      (() => {})(`当前页: ${val}`);
      this.currentPage = val;
      if (this.postbe_crmlevel == "1") {
        if (this.current == 0) {
          this.getLossclientData("0");
        } else {
          this.getLossclientData("1");
        }
      } else {
        this.getLossclientData("1");
      }
    },
    handleSelectionChange(val) {
      this.MultipleClues = val;
      if (val != "") {
        let timer = setTimeout(() => {
          this.buttonHide = true;
          clearTimeout(timer);
        }, 10);
      } else {
        this.buttonHide = false;
      }
    },
    // tab切换
    addClass(index) {
      if (index != this.current) {
        this.selectForm = {
          rangeTime: "",
          level: null,
          source: "",
          keyword: "",
        };
        this.current = index;
        this.currentPage = 1;
        if (index == 0) {
          this.getLossclientData("0");
        } else {
          this.getLossclientData("1");
        }
      }
    },
    // 导出操作
    daochu() {
      let params_str = "",
        is_export = 1;
      let type = "";
      if (this.current == 0) {
        type = "0";
      } else {
        type = "1";
      }
      let $source = this.selectForm.source;
      if ($source == this.$t("Losscustomermanage.an")) {
        $source = "";
      }
      params_str = `&client_ischaserlapsed=${type}&client_source=${$source}&keyword=${this.selectForm.keyword}`;
      let url = storeLosscustomerManage.getLossclient1();
      params_str = `${url}?marketer_id=${this.marketer_id}&token=${this.token}&school_id=${this.school_id}&company_id=${this.company_id}&re_postbe_id=${this.re_postbe_id}&postbe_crmuserlevel=${this.postbe_crmuserlevel}&language_type=${this.language_type}&is_export=${is_export}${params_str}`;
      (() => {})(params_str);
      if (this.tableData.length > 0) {
        window.open(this.$buildExportUrl(params_str), "_blank");
      } else {
        this.$message.error(this.$t("Common.exportTips"));
      }
    },
  },
  watch: {
    changeSchoolVisible(n) {
      if (!n) {
        this.$refs["changeSchoolForm"].resetFields();
      }
    },
  },
};
</script>
<style lang="less">
@import url("../../assets/less/manage.less");
@import url("losscustomerManage.less");
.losscustomerManage {
  height: 100vh;
  font-size: 20px;
}
</style>
